module.exports = __webpack_public_path__ + "img/20.aeabf62a.jpg";